import { createFileRoute } from '@tanstack/react-router';

// `?tab=` sub-nav search param is read permissively (useSearch({ strict: false })) inside
// AttendancePage, matching the existing /time/logs?tab= convention this route supersedes — not
// validated at the route level.
export const Route = createFileRoute('/time/attendance')({});
